import { captureException } from "@sentry/react";
import { useQueryClient } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import { RESET } from "jotai/utils";
import { useState } from "react";
import { clearPersistedQueryCache } from "web_myplann/Shared/QueryClient";
import { userState } from "web_myplann/Shared/State/UserAtom";
import { device } from "web_myplann/Utils/device";

export const useLogOut = () => {
	const queryClient = useQueryClient();
	const resetUser = useSetAtom(userState);
	const [isPending, setIsPending] = useState(false);

	const run = async (action: () => Promise<unknown>) => {
		if (isPending) {
			return;
		}
		setIsPending(true);
		clearPersistedQueryCache(queryClient);
		resetUser(RESET);

		try {
			if (window.ReactNativeWebView) {
				await action().catch(captureException);
			}
		} finally {
			setIsPending(false);
		}
	};

	return {
		isPending,
		logOut: () => run(() => device.logOut()),
		removeAccount: () => run(() => device.removeUser()),
	};
};
